import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import X46MK2ConfiguratorImageWithOverlays from './X46MK2ConfiguratorImageWithOverlays'
import ConfiguratorOption from './../ConfiguratorOption'
import RadioGroup from './../RadioGroup'
import { withTranslation, Trans } from 'react-i18next'
import { exteriorView11ImageOptions } from './views/ExteriorView11'

class X46MK2Wheel extends Component {
  constructor (props) {
    super(props)
    this.handleWheelChange = this.handleWheelChange.bind(this)
  }

  handleWheelChange (newValue) {
    if (this.props.onChange) {
      this.props.onChange({
        ...this.props.configuration,
        Wheel: newValue
      })
    }
  }

  render () {
    let imageOptions = exteriorView11ImageOptions

    let image = (
      <X46MK2ConfiguratorImageWithOverlays
        boat='X46MK2'
        configuration={this.props.configuration}
        options={imageOptions}
      />
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='Wheels' />
          </h1>
          <p>
            <Trans defaults='The electronic equipment shown on this render is optional. Please contact your local dealer for further information.' />
          </p>
          <RadioGroup
            label='Options:'
            options={this.props.wheelOptions}
            value={this.props.configuration.Wheel}
            onChange={this.handleWheelChange}
          />
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(X46MK2Wheel)



// WEBPACK FOOTER //
// ./src/X46MK2/X46MK2Wheel.js